import EventManager from "../../../manager/event_manager";

//多行多列无限循环列表(只能使用item大小固定的时候) 使用方法请看listview_demo.ts
export class ListView {
    private m_scrollview: cc.ScrollView;
    private m_view: cc.Node;
    private m_content: cc.Node;
    private m_item_prefab: cc.Node;
    private m_node_pool: cc.Node[];

    private m_dir: number;
    private m_width: number;
    private m_height: number;
    private m_gap_x: number;
    private m_gap_y: number;
    private m_row: number;
    private m_col: number;
    private m_item_width: number;
    private m_item_height: number;
    private m_cb_host: any;
    private item_update_func: (item: cc.Node, data: any, index: number,item_intact ?:any) => void;
    private recycle_cb: (item: cc.Node) => void;
    private select_cb: (data: any, index: number) => void;
    private item_select_func: (item: cc.Node, is_select: boolean, index: number) => void;
    private scroll_to_end_cb: () => void;
    private item_click_func: (item: cc.Node) => void
    private item_click_ex_func: (item: any) => void
    private m_auto_scrolling: boolean;
    private m_items: ListItem[];
    private m_start_index: number;
    private m_stop_index: number;
    private m_datas: any[];
    private m_selected_index: number = -1;

    constructor(params: ListViewParams) {
        this.m_scrollview = params.scrollview;
        this.m_view = params.view;
        this.m_content = params.content;
        this.m_item_prefab = params.item_prefab;
        this.m_item_prefab.active = false;
        this.m_item_width = this.m_item_prefab.width;
        this.m_item_height = this.m_item_prefab.height;
        this.m_dir = params.direction || ListViewDir.Vertical;
        this.m_width = params.width || this.m_view.width;
        this.m_height = params.height || this.m_view.height;
        this.m_gap_x = params.gap_x || 0;
        this.m_gap_y = params.gap_y || 0;
        this.m_row = params.row || 1;
        this.m_col = params.column || 1;
        this.m_cb_host = params.cb_host;
        this.item_update_func = params.item_update_func;
        this.recycle_cb = params.recycle_cb;
        this.select_cb = params.select_cb;
        this.item_select_func = params.item_select_func;
        this.scroll_to_end_cb = params.scroll_to_end_cb;
        this.item_click_func = params.item_click_func;
        this.item_click_ex_func = params.item_click_ex_func;
        this.m_auto_scrolling = params.auto_scrolling || false;
        this.m_node_pool = [];

        if (this.m_dir == ListViewDir.Vertical) {
            let real_width: number = (this.m_item_width + this.m_gap_x) * this.m_col - this.m_gap_x;
            if (real_width > this.m_width) {
                cc.log("real width > width, resize scrollview to realwidth,", this.m_width, "->", real_width);
                this.m_width = real_width;
            }
            this.m_content.width = this.m_width;
        }
        else {
            let real_height: number = (this.m_item_height + this.m_gap_y) * this.m_row - this.m_gap_y;
            if (real_height > this.m_height) {
                cc.log("real height > height, resize scrollview to realheight,", this.m_height, "->", real_height);
                this.m_height = real_height;
            }
            this.m_content.height = this.m_height;
        }
        this.m_view.setContentSize(this.m_width, this.m_height);
        this.m_scrollview.vertical = this.m_dir == ListViewDir.Vertical;
        this.m_scrollview.horizontal = this.m_dir == ListViewDir.Horizontal;
        this.m_scrollview.inertia = true;
        this.m_scrollview.node.on("scrolling", this.on_scrolling, this);
        this.m_scrollview.node.on("scroll-to-bottom", this.on_scroll_to_end, this);
        this.m_scrollview.node.on("scroll-to-right", this.on_scroll_to_end, this);

        //@ts-ignore
        let beforDestroy = this.m_scrollview._onPreDestroy.bind(this.m_scrollview);
        //@ts-ignore
        this.m_scrollview._onPreDestroy = ()=>{
            if (beforDestroy) {
                beforDestroy();
            }
            this.destroyListView();
        }

        //网页布局变化时需要重置item 位置
        EventManager.instance.on('_resize_',this.resize,this,true);
    }

    resize(){
        if (this.m_scrollview.node && this.m_scrollview.node.isValid) {
            //下一帧刷新布局
            let node = this.m_scrollview.node;
            let sequence = cc.sequence(cc.delayTime(0) , cc.callFunc(()=>{
                this.resize_content();
                this.on_scrolling();
            }));
            node.stopAllActions();
            node.runAction(sequence);
        } 
    }

    get datas(): any[] {
        return this.m_datas;
    }

    get items():ListItem[]{

        return this.m_items;
    }

    get selected_index(): number {
        return this.m_selected_index;
    }

    get stop_index(){

        return this.m_stop_index;
    }

    get selectd_data(): any {
        let item: ListItem = this.m_items[this.m_selected_index];
        if (item) {
            return item.data;
        }
        return null;
    }

    top_item(itemIndex : number){

        if (itemIndex == 0) {            
            return false;
        }

        let item = this.items[itemIndex];
        if (item) {
            
            let dataList : any[] = [];
            dataList[0] = item.data;

            for (let i = 0; i < this.items.length; i++) {
                const ele = this.items[i];
                if (i == itemIndex) {
                    continue;
                }
                dataList.push(ele.data);
            }
            
            let self = this;
            dataList.forEach((data,index)=>{
                self.refresh_item(index,data);
            })

            return true;
        }

        return false
    }

    set_data(datas: any[]) {
        if (!datas) {
            return;
        }
        this.clear_items();
        this.m_items = [];      
        this.m_datas = datas.concat([]);
        this.m_selected_index = -1
        datas.forEach((data) => {
            let item: ListItem = this.pack_item(data);
            this.m_items.push(item);
        });
        this.layout_items(0);
        this.resize_content();
        this.m_start_index = -1;
        this.m_stop_index = -1;
        if (this.m_dir == ListViewDir.Vertical) {
            this.m_content.y = 0;
        }
        else {
            this.m_content.x = 0;
        }
        if (this.m_items.length > 0) {
            this.on_scrolling();
        }
    }


    insert_data(index: number, ...datas: any[]) {
        if (datas.length == 0) {
            cc.log("nothing to insert");
            return;
        }
        if (!this.m_items) {
            this.m_items = [];
        }
        if (!this.m_datas) {
            this.m_datas = [];
        }
        if (index < 0 || index > this.m_items.length) {
            cc.warn("invalid index", index);
            return;
        }
        let is_append: boolean = index == this.m_items.length;
        //let items: ListItem[] = [];

        datas.forEach((data) => {
            //let item: ListItem = this.pack_item(data);
            //items.push(item);                    
            this.m_items.splice(index, 0, this.pack_item(data));   
            this.m_datas.splice(index, 0, data); 
        });
                        
        // this.m_datas.splice(index, 0, ...datas);
        // this.m_items.splice(index, 0, ...items);        
        
        this.layout_items(index);
        this.resize_content();
        this.m_start_index = -1;
        this.m_stop_index = -1;

        if (this.m_auto_scrolling && is_append) {
            this.scroll_to_end();
        }
        this.on_scrolling();
    }

    remove_data(index: number, count: number = 1) {
        if (!this.m_items) {
            cc.log("call set_data before call this method");
            return;
        }
        if (index < 0 || index >= this.m_items.length) {
            cc.warn("invalid index", index);
            return;
        }
        if (count < 1) {
            cc.log("nothing to remove");
            return;
        }
        let old_length: number = this.m_items.length;
        let del_items: ListItem[] = this.m_items.splice(index, count);
        this.m_datas.splice(index, count);
        //回收node
        del_items.forEach((item) => {
            this.recycle_item(item);
        });

        //重新排序index后面的
        if (index + count < old_length) {
            this.layout_items(index);
        }
        this.resize_content();
        if (this.m_items.length > 0) {
            this.m_start_index = -1;
            this.m_stop_index = -1;
            this.on_scrolling();
        }
    }

    append_data(...datas: any[]) {
        if (!this.m_items) {
            this.m_items = [];
        }
        this.insert_data(this.m_items.length, ...datas);
    }

    scroll_to(index: number) {
        if (this.m_dir == ListViewDir.Vertical) {
            const min_y = this.m_height - this.m_content.height;
            if (min_y >= 0) {
                cc.log("no need to scroll");
                return;
            }
            let [_, y] = this.vertical_layout(index, this.m_item_width, this.m_item_height, this.m_col, this.m_gap_x, this.m_gap_y, false);
            if (y < min_y) {
                y = min_y;
                cc.log("content reach bottom");
            }
            if (y > 0) {
                y = 0;
                cc.log("content reach top");
            }
            this.m_scrollview.setContentPosition(cc.v2(this.m_content.x, -y));
            this.on_scrolling();
        }
        else {
            const max_x = this.m_content.width - this.m_width;
            if (max_x <= 0) {
                cc.log("no need to scroll");
                return;
            }
            let [x, _] = this.horizontal_layout(index, this.m_item_width, this.m_item_height, this.m_row, this.m_gap_x, this.m_gap_y, false);
            if (x > max_x) {
                x = max_x;
                cc.log("content reach right");
            }
            if (x < 0) {
                x = 0;
                cc.log("content reach left");
            }
            this.m_scrollview.setContentPosition(cc.v2(-x, this.m_content.y));
            this.on_scrolling();
        }
    }

    scroll_to_end() {
        if (this.m_dir == ListViewDir.Vertical) {
            this.m_scrollview.scrollToBottom();
        }
        else {
            this.m_scrollview.scrollToRight();
        }
    }

    refresh_item(index: number, data: any) {
        if (!this.m_items) {
            cc.log("call set_data before call this method");
            return;
        }
        if (index < 0 || index >= this.m_items.length) {
            cc.warn("invalid index", index);
            return;
        }
        let item: ListItem = this.m_items[index];
        item.data = data;
        this.m_datas[index] = data;
        if (item.node) {
            if (this.recycle_cb) {
                this.recycle_cb.call(this.m_cb_host, item.node);
            }
            this.item_update_func.call(this.m_cb_host, item.node, item.data, index,item);
        }
    }

    select_item(index) {
        if (index == this.m_selected_index) {
            return;
        }
        if (this.m_selected_index != -1) {
            this.inner_select_item(this.m_selected_index, false);
        }
        this.inner_select_item(index, true);
    }

    public destroyListView() {
        this.clear_items();
        if (this.m_node_pool) {
            this.m_node_pool.forEach((node) => {
                node.destroy();
            });
        }
        this.m_node_pool = null;
        this.m_items = null;
        this.m_datas = null;

        if (cc.isValid(this.m_scrollview.node)) {
            this.m_scrollview.node.off("scrolling", this.on_scrolling, this);
            this.m_scrollview.node.off("scroll-to-bottom", this.on_scroll_to_end, this);
            this.m_scrollview.node.off("scroll-to-right", this.on_scroll_to_end, this);
        }
        EventManager.instance.off('_resize_',this.resize,this);
    }

    private on_scroll_to_end() {
        if (this.scroll_to_end_cb) {
            this.scroll_to_end_cb.call(this.m_cb_host);
        }
    }

    private on_scrolling() {
        if (!this.m_items || !this.m_items.length) {
            return;
        }
        if (this.m_dir == ListViewDir.Vertical) {
            let posy: number = this.m_content.y;
            if (posy < 0) {
                posy = 0;
            }
            if (posy > this.m_content.height - this.m_height) {
                posy = this.m_content.height - this.m_height;
            }
            let start: number = 0;
            let stop: number = this.m_items.length - 1;
            let viewport_start: number = -posy;
            let viewport_stop: number = viewport_start - this.m_height * 2;//修改：this.m_height->this.m_height*1.5防止显示不全

            while (this.m_items[start].y - this.m_item_height > viewport_start) {
                start++;
            }

            while (this.m_items[stop].y + this.m_item_height < viewport_stop) {
                stop--;
            }
            if (start != this.m_start_index && stop != this.m_stop_index) {
                this.m_start_index = start;
                this.m_stop_index = stop;
                this.render_items();
            }
        }
        else {
            let posx: number = this.m_content.x;
            if (posx > 0) {
                posx = 0;
            }
            if (posx < this.m_width - this.m_content.width) {
                posx = this.m_width - this.m_content.width;
            }
            let start: number = 0;
            let stop: number = this.m_items.length - 1;
            let viewport_start: number = -posx;
            let viewport_stop: number = viewport_start + this.m_width * 1.5;//水平方向显示不全修改
            while (this.m_items[start].x + this.m_item_width < viewport_start) {
                start++;
            }
            while (this.m_items[stop].x - this.m_item_width > viewport_stop) {
                stop--;
            }
            if (start != this.m_start_index && stop != this.m_stop_index) {
                this.m_start_index = start;
                this.m_stop_index = stop;
                this.render_items();
            }
        }
    }

    private inner_select_item(index: number, is_select: boolean) {
        let item: ListItem = this.m_items[index];
        if (!item) {
            cc.warn("inner_select_item index is out of range{", 0, this.m_items.length - 1, "}", index);
            return;
        }
        item.is_select = is_select;
        if (item.node && this.item_select_func) {
            this.item_select_func.call(this.m_cb_host, item.node, is_select, index);
        }
        if (is_select) {
            this.m_selected_index = index;
            if (this.select_cb) {
                this.select_cb.call(this.m_cb_host, item.data, index);
            }
        }
    }

    private spawn_node(index: number): cc.Node {
        let node: cc.Node = this.m_node_pool.pop();
        if (!node) {
            node = cc.instantiate(this.m_item_prefab);
            node.active = true;
        }
        node.parent = this.m_content;
        if (this.item_click_func || this.item_click_ex_func) {
            node.off("click", this.item_click, this)
            node.on("click", this.item_click, this)
        }
        return node;
    }

    private item_click(event: cc.Button) {
        let node: cc.Node = event.node
        if(this.item_click_func)
        {
            this.item_click_func.call(this.m_cb_host, node)
        }
        if(this.item_click_ex_func != null)
        {
            let item: ListItem;
            for(let i=0,len=this.m_items.length;i < len; i++)
            {
                if(this.m_items[i].node == node)
                {
                    item = this.m_items[i];
                    break;
                }
            }
            if(item != null)
            {
                this.item_click_ex_func.call(this.m_cb_host, item.data)
            }
        }
    }



    private recycle_item(item: ListItem) {
        if (item.node && cc.isValid(item.node)) {
            if (this.recycle_cb) {
                this.recycle_cb.call(this.m_cb_host, item.node);
            }
            item.node.removeFromParent();
            this.m_node_pool.push(item.node);
            item.node = null;
        }
    }

    private clear_items() {
        if (this.m_items) {
            this.m_items.forEach((item) => {
                this.recycle_item(item);
            });
        }
    }

    private render_items() {
        //console.log(" stop index : " ,this.m_stop_index);
        let item: ListItem;
        for (let i: number = 0; i < this.m_start_index; i++) {
            item = this.m_items[i];
            if (item.node) {
                this.recycle_item(item);
            }
        }
        for (let i: number = this.m_items.length - 1; i > this.m_stop_index; i--) {
            item = this.m_items[i];
            if (item.node) {
                this.recycle_item(item);
            }
        }
        for (let i: number = this.m_start_index; i <= this.m_stop_index; i++) {
            item = this.m_items[i];
            if (!item.node) {
                item.node = this.spawn_node(i);
                item.node.setPosition(item.x, item.y);
                this.item_update_func.call(this.m_cb_host, item.node, item.data, i, item);
                if (this.item_select_func) {
                    this.item_select_func.call(this.m_cb_host, item.node, item.is_select, i);
                }
            }else{
                item.node.setPosition(item.x, item.y);
            }
            
            
        }
    }

    private pack_item(data: any): ListItem {
        return { x: 0, y: 0, data: data, node: null, is_select: false };
    }

    private layout_items(start: number) {
        for (let index: number = start, stop: number = this.m_items.length; index < stop; index++) {
            let item: ListItem = this.m_items[index];
            if (this.m_dir == ListViewDir.Vertical) {
                [item.x, item.y] = this.vertical_layout(index, this.m_item_width, this.m_item_height, this.m_col, this.m_gap_x, this.m_gap_y);
            }
            else {
                [item.x, item.y] = this.horizontal_layout(index, this.m_item_width, this.m_item_height, this.m_row, this.m_gap_x, this.m_gap_y);
            }
        }
    }

    private resize_content() {
        if (!this.m_items || !this.m_items.length) {
            return;
        }
        if (this.m_items.length <= 0) {
            this.m_content.width = 0;
            this.m_content.height = 0;
            return;
        }
        let last_item: ListItem = this.m_items[this.m_items.length - 1];
        if (this.m_dir == ListViewDir.Vertical) {
            this.m_content.height = Math.max(this.m_height, this.m_item_height / 2 - last_item.y);
        }
        else {
            this.m_content.width = Math.max(this.m_width, last_item.x + this.m_item_width / 2);
        }
    }

    private vertical_layout(index: number, item_width: number, item_height: number, column: number = 1, gap_x: number = 0, gap_y: number = 0, halfOffset: boolean = true): [number, number] {
        let x: number = (index % column) * (item_width + gap_x);
        let y: number = -Math.floor(index / column) * (item_height + gap_y);
        if (halfOffset) {
            return [x + item_width / 2, y - item_height / 2];
        } else {
            return [x, y];
        }
    }

    private horizontal_layout(index: number, item_width: number, item_height: number, row: number = 1, gap_x: number = 0, gap_y: number = 0, halfOffset: boolean = true): [number, number] {
        let x: number = Math.floor(index / row) * (item_width + gap_x);
        let y: number = -(index % row) * (item_height + gap_y);

        if (halfOffset) {
            return [x + item_width / 2, y - item_height / 2];
        } else {
            return [x, y];
        }
    }
}

export enum ListViewDir {
    Vertical = 1,
    Horizontal = 2,
}

type ListViewParams = {
    scrollview: cc.ScrollView;
    view: cc.Node;
    content: cc.Node;
    item_prefab: cc.Node;                                                           //item预制
    direction?: ListViewDir;                                                        //滚动方向
    width?: number;                                                                 //显示区域宽 默认取view的宽
    height?: number;                                                                //显示区域高 默认取view的高
    gap_x?: number;                                                                 //item横向间隔
    gap_y?: number;                                                                 //item竖向间隔
    row?: number;                                                                   //水平方向排版时，垂直方向上的行数
    column?: number;                                                                //垂直方向排版时，水平方向上的列数
    cb_host?: any;                                                                  //回调函数host this
    item_update_func: (item: cc.Node, data: any, index: number,item_intact ?:any) => void;            //item更新func
    recycle_cb?: (item: cc.Node) => void;                                           //回收时的回调
    select_cb?: (data: any, index: number) => void;                                 //item选中回调
    item_select_func?: (item: cc.Node, is_select: boolean, index: number) => void;  //item选中效果func
    scroll_to_end_cb?: () => void;                                                  //滚动到尽头的回调
    auto_scrolling?: boolean;                                                       //append时自动滚动到尽头
    item_click_func?: (item: cc.Node) => void                                       //点击事件,参数是点击的node
    item_click_ex_func?: (data: any) => void                                        //点击事件2,参数是点击的ListItem的data(这是新加的,旧的依旧保留)
}

export type ListItem = {
    x: number;
    y: number;
    data: any;
    node: cc.Node;
    is_select: boolean;
}